"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketServiceManager = void 0;
const providers_1 = require("@ethersproject/providers");
const sdk_1 = require("@yfi/sdk");
const coincap_1 = require("./coincap/coincap");
const coingecko_1 = require("./coingecko/coingecko");
const foxy_1 = require("./foxy/foxy");
const idle_1 = require("./idle/idle");
const osmosis_1 = require("./osmosis/osmosis");
const yearn_tokens_1 = require("./yearn/yearn-tokens");
const yearn_vaults_1 = require("./yearn/yearn-vaults");
class MarketServiceManager {
    constructor(args) {
        const { coinGeckoAPIKey = '', providerUrls, yearnChainReference } = args;
        const { jsonRpcProviderUrl } = providerUrls;
        // TODO(0xdef1cafe): after chain agnosticism, we need to dependency inject a chainReference here
        // YearnVaultMarketCapService deps
        const network = yearnChainReference !== null && yearnChainReference !== void 0 ? yearnChainReference : 1; // 1 for mainnet
        const provider = new providers_1.JsonRpcProvider(jsonRpcProviderUrl);
        const yearnSdk = new sdk_1.Yearn(network, { provider });
        this.marketProviders = [
            // Order of this MarketProviders array constitutes the order of providers we will be checking first.
            // More reliable providers should be listed first.
            new coingecko_1.CoinGeckoMarketService({ coinGeckoAPIKey }),
            new coincap_1.CoinCapMarketService(),
            new yearn_vaults_1.YearnVaultMarketCapService({ yearnSdk }),
            new yearn_tokens_1.YearnTokenMarketCapService({ yearnSdk }),
            new idle_1.IdleMarketService({ coinGeckoAPIKey, providerUrls }),
            new osmosis_1.OsmosisMarketService(),
            new foxy_1.FoxyMarketService({ coinGeckoAPIKey, providerUrls }),
        ];
    }
    async findAll(args) {
        let result = null;
        // Go through market providers listed above and look for market data for all assets.
        // Once data is found, exit the loop and return result. If no data is found for any
        // provider, throw an error.
        for (let i = 0; i < this.marketProviders.length && !result; i++) {
            try {
                result = await this.marketProviders[i].findAll(args);
            }
            catch (e) {
                console.info(e);
            }
        }
        if (!result)
            throw new Error('Cannot find market service provider for market data.');
        return result;
    }
    async findByAssetId({ assetId }) {
        let result = null;
        // Loop through market providers and look for asset market data. Once found, exit loop.
        for (let i = 0; i < this.marketProviders.length && !result; i++) {
            try {
                result = await this.marketProviders[i].findByAssetId({ assetId });
            }
            catch (e) {
                // Swallow error, not every asset will be with every provider.
            }
        }
        if (!result)
            return null;
        return result;
    }
    async findPriceHistoryByAssetId({ assetId, timeframe, }) {
        let result = null;
        // Loop through market providers and look for asset price history data. Once found, exit loop.
        for (let i = 0; i < this.marketProviders.length && !(result === null || result === void 0 ? void 0 : result.length); i++) {
            try {
                result = await this.marketProviders[i].findPriceHistoryByAssetId({ assetId, timeframe });
            }
            catch (e) {
                // Swallow error, not every asset will be with every provider.
            }
        }
        if (!result)
            return [];
        return result;
    }
}
exports.MarketServiceManager = MarketServiceManager;
